export default "__VITE_ASSET__1cPMckKp__"